import React, { useEffect, useState } from "react";
import { Table, Form, Select, Button, Space, Row, Col, Tooltip } from "antd";
import "../Pages/CSS/DonnesBases.css";
import { GestionPaieService } from "../Services/GestionPaieService";
import { DeleteFilled } from "@ant-design/icons";
import confirm from "antd/es/modal/confirm";
const { Option } = Select;
const ModelisationComptable = () => {
  const [form] = Form.useForm();
  const [editing, setEditing] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10)
  const [comptes, setComptes] = useState([]);
  const [rubriques, setRubriques] = useState([]);
  const gestionPaieService = new GestionPaieService();

  const userProfil = localStorage.getItem("profil");

  const fetchAllData = async () => {
    try {
      const modelisation = await gestionPaieService.getAllModelisation();
      setTableData(modelisation);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  const fetchRubrique = async () => {
    try {
      const response = await gestionPaieService.getAllRubriques();
      setRubriques(response);
    } catch (error) {
      console.error("Erreur lors de la récupération des périodes :", error);
    }
  };

  const fetchCompte = async () => {
    try {
      const response = await gestionPaieService.getAllCompta();
      setComptes(response);
    } catch (error) {
      console.error("Erreur lors de la récupération des périodes :", error);
    }
  };

  useEffect(() => {
    fetchAllData();
    fetchCompte();
    fetchRubrique();
  }, []);

  const handleUpdate = async () => {
    // Récupérer les valeurs actuelles du formulaire
    const values = await form.validateFields();

    const payload = {
      compte: values.compte.split(" - ")[0], // Extraction de l'identifiant du compte
      rubrique: values.rubrique.split(" - ")[0], // Extraction de l'identifiant de la rubrique
      sens: values.sens,
    };

    try {
      const updatedData = await gestionPaieService.updateModelisation(payload);
      // Mettre à jour les données du tableau avec les nouvelles données
      const updatedTableData = tableData.map((item) => {
        if (
          item.compte === payload.compte &&
          item.rubrique === payload.rubrique
        ) {
          return { ...item, ...updatedData };
        }
        return item;
      });
      setTableData(updatedTableData);
      await fetchAllData();
      setEditing(false);
      form.resetFields();
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
    }
  };

  const handleAddModelisation = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        compte: values.compte, // Extraction de l'identifiant du compte
        rubrique: values.rubrique, // Extraction de l'identifiant de la rubrique
        sens: values.sens,
      };

      const response = await gestionPaieService.addModelisation(payload);

      await fetchAllData();
      setEditing(false);
      form.resetFields();
    } catch (error) {
      console.error(
        "Erreur lors de la validation ou de l’ajout de données :",
        error
      );
      // Pas besoin de lancer d'autres logiques, car form.validateFields() a échoué
    }
  };

  const handleDelete = async (compte, rubrique) => {
    try {
      await gestionPaieService.deleteModelisation(compte, rubrique);
      // Rafraîchir les données après la suppression
      await fetchAllData();
      form.resetFields();
      setEditing(false);
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
    }
  };

  /* const columns = [
    {
      title: "Compte",
      dataIndex: "compte",
      key: "compte",
      render: (text, record) => `${text} - ${record.libelle}`,
    },
    {
      title: "Rubrique",
      dataIndex: "rubrique",
      key: "rubrique",
      render: (text, record) => `${text} - ${record.intitule}`,
    },
    {
      title: "Sens",
      dataIndex: "sens",
      key: "sens",
      align: "center",
    },
    userProfil !== 'role_15' ? {
   
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),

      align: "center",
      fixed: "right", // Fixe la colonne à droite
      render: (text, record) => (
        <span>
          <Tooltip title="Supprimer">
            <DeleteFilled
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => showDeleteConfirm(record.compte, record.rubrique)}
            />
          </Tooltip>
        </span>
      ),
    } : null,
  ].filter(column => column); */

  const columns = [
    {
      title: "Compte",
      dataIndex: "compte",
      key: "compte",
      sorter: (a, b) => a.compte.localeCompare(b.compte),
      render: (text, record) => `${text} - ${record.libelle}`,
    },
    {
      title: "Rubrique",
      dataIndex: "rubrique",
      key: "rubrique",
      sorter: (a, b) => a.rubrique.toString().localeCompare(b.rubrique.toString()),
      render: (text, record) => `${text} - ${record.intitule}`,
    },
    {
      title: "Sens",
      dataIndex: "sens",
      key: "sens",
      align: "center",
      sorter: (a, b) => a.sens.localeCompare(b.sens),
    },
    ...(userProfil !== 'role_15'
      ? [
        {
          title: (
            <div
              style={{
                backgroundColor: "#010f1c",
                color: "white",
                padding: "1px",
              }}
            ></div>
          ),
          align: "center",
          fixed: "right",
          render: (text, record) => (
            <span>
              <Tooltip title="Supprimer">
                <DeleteFilled
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => showDeleteConfirm(record.compte, record.rubrique)}
                />
              </Tooltip>
            </span>
          ),
        },
      ]
      : []),
  ].filter((column) => column);


  const onRowClick = (record) => {
    form.setFieldsValue({
      compte: `${record.compte} - ${record.libelle}`,
      rubrique: `${record.rubrique} - ${record.intitule}`,
      sens: record.sens,
    });
    setEditing(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setEditing(false);
  };

  const showAddConfirm = async () => {
    confirm({
      title: "Voulez-vous vraiment ajouter cette rubrique?",
      content: "Cette action ajoutera une nouvelle rubrique.",
      onOk: handleAddModelisation,
      onCancel() {
        console.log("Ajout annulé");
      },
    });
  };

  const showUpdateConfirm = async () => {
    confirm({
      title: "Voulez-vous vraiment modifier cette rubrique?",
      content:
        "Cette action modifiera les informations de la rubrique sélectionnée.",
      onOk: handleUpdate,
      onCancel() {
        console.log("Modification annulée");
      },
    });
  };
  const showDeleteConfirm = (compte, rubrique) => {
    confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette rubrique?",
      content: "Cette action est irréversible.",
      okText: "Oui",
      okType: "danger",
      cancelText: "Non",
      onOk: () => {
        handleDelete(compte, rubrique);
      },
      onCancel() {
        console.log("Suppression annulée");
      },
    });
  };

  return (
    <div>
      {userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' && (
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="compte"
                label="Compte"
                rules={[{ required: true, message: "Le compte est obligatoire" }]}
              >
                <Select
                  placeholder="Sélectionnez un compte"
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303" }}
                  disabled={editing}
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {comptes.map((compt) => (
                    <Option key={compt.compte} value={compt.compte}>
                      {`${compt.compte} - ${compt.intitule}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="rubrique"
                label="Rubrique"
                rules={[
                  { required: true, message: "Le rubrique est obligatoire" },
                ]}
              >
                <Select
                  placeholder="Sélectionnez une rubrique"
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303" }}
                  disabled={editing}
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {rubriques.map((rubric) => (
                    <Option key={rubric.code} value={rubric.code}>
                      {`${rubric.code} - ${rubric.intitule}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="sens"
                label="Sens"
                rules={[{ required: true, message: "Le sens est obligatoire" }]}
              >
                <Select
                  placeholder="Sélectionnez un sens"
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303" }}
                >
                  <Option value="D">Débit</Option>
                  <Option value="C">Crédit</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6} style={{ display: "flex", justifyContent: "right" }}>
              {editing ? (
                <Space>
                  <Button
                    style={{ marginTop: 10 }}
                    type="primary"
                    onClick={showUpdateConfirm}
                    htmlType="submit"
                  >
                    Modifier
                  </Button>
                  <Button style={{ marginTop: 10 }} onClick={handleCancel}>
                    Annuler
                  </Button>
                </Space>
              ) : (
                <Space>
                  <Button
                    style={{ marginTop: 10 }}
                    type="primary"
                    htmlType="submit"
                    onClick={showAddConfirm}
                  >
                    Enregistrer
                  </Button>
                </Space>
              )}
            </Col>
          </Row>
        </Form>
      )}
      <Table
        dataSource={tableData}
        columns={columns}
        showSorterTooltip={false}
        scroll={{
          x: true,
        }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header1-table"
        bordered
        onRow={(record) => ({
          onClick: () => onRowClick(record),
        })}
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
      />
    </div>
  );
};

export default ModelisationComptable;
